import Box from '@mui/material/Box';
import { ReactNode } from 'react';

export type TimelineChartScrollportProps = {
  children: ReactNode;
};

/**
 * Horizontal scroll for the SVG; `overflow-y: hidden` so portaled tooltip layers do not stretch layout height.
 */
export function TimelineChartScrollport({ children }: TimelineChartScrollportProps) {
  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        overflowX: 'auto',
        overflowY: 'hidden',
      }}
    >
      {children}
    </Box>
  );
}
